import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

export default function Kasanie() {
    const { id } = useParams();
    const [searchParams] = useSearchParams();

    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        const link = `https://qr.nspk.ru/${id}?${searchParams.toString()}`;

        try {
            // eslint-disable-next-line no-undef
            const slideUpWidget = new SlideUpWidget(window.localStorage, window.navigator);
            slideUpWidget.showBankSelector(link);
        } catch {
            setError('Не удалось создать ссылку на оплату.');
        }
    }, []);

    return (
        <div>
            <p>{error}</p>
        </div>
    );
}
